import { render, staticRenderFns } from "./StatisticsMarksGeneralView.vue?vue&type=template&id=2cd4663c"
import script from "./StatisticsMarksGeneralView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports